export const SVR3DFL = 'SVR3DFL'
export const WEB_CLR = 'WEB_CLR'